import React from 'react';

import CircularProgress from '@mui/material/CircularProgress';

export interface InfoCardProps {
    color: string;
    loading?: boolean;
}

const InfoCard: React.FC<InfoCardProps> = (props) => {
    return (
        <div className={`w-full rounded shadow p-5 text-white leading-none ${props.color}`}>
            {
                props.loading ? (
                    <div className="flex items-center justify-center text-white">
                        <CircularProgress color="inherit" />
                    </div>
                ) : props.children
            }
        </div>  
    );
}

export default InfoCard;